import React, { useState } from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import "./FloatingContact.css";

const PHONE = "917574098964";
const DISPLAY_PHONE = "+91 75740 98964";

export default function FloatingContact() {
  const [active, setActive] = useState(null);

  const callNow = () => {
    window.location.href = `tel:+${PHONE}`;
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello Bhole Cab Service, I would like to book a cab."
    );

    window.open(
      `https://wa.me/${PHONE}?text=${message}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="floating-contact">

      {/* CALL BUTTON */}
      <button
        type="button"
        className={`contact-float call-float ${
          active === "call" ? "is-open" : ""
        }`}
        onMouseEnter={() => setActive("call")}
        onMouseLeave={() => setActive(null)}
        onTouchStart={() => setActive("call")}
        onClick={callNow}
        aria-label={`Call ${DISPLAY_PHONE}`}
      >
        <span className="contact-float-icon">
          <FaPhoneAlt />
        </span>

        <span className="contact-float-number">
          {DISPLAY_PHONE}
        </span>
      </button>

      {/* WHATSAPP BUTTON */}
      <button
        type="button"
        className={`contact-float whatsapp-float ${
          active === "whatsapp" ? "is-open" : ""
        }`}
        onMouseEnter={() => setActive("whatsapp")}
        onMouseLeave={() => setActive(null)}
        onTouchStart={() => setActive("whatsapp")}
        onClick={openWhatsApp}
        aria-label={`WhatsApp ${DISPLAY_PHONE}`}
      >
        <span className="contact-float-icon">
          <FaWhatsapp />
        </span>

        <span className="contact-float-number">
          {DISPLAY_PHONE}
        </span>
      </button>

    </div>
  );
}